import { useState } from 'react'
import { toast } from 'react-toastify'
import Button from '../../components/Button'
import { Toast } from '../../config/Toast'
import RecalculateService from '../../services/Recalculate'

const MAX_RANGE_DAYS = 31

const RecalculateItem = (props) => {
  const [btnLoading, setBtnLoading] = useState(false)

  const notifySuccess = (message) => toast.success(message, Toast)
  const notifyFailed = (message) => toast.error(message, Toast)

  const recalculateHandler = () => {
    if (props.startDate === null) {
      notifyFailed('Date is required')
      return
    }

    // End Date kosong = satu hari (Start Date), seperti perilaku sebelumnya
    const start = props.startDate
    const end = props.endDate || props.startDate

    if (end < start) {
      notifyFailed('End Date tidak boleh sebelum Start Date')
      return
    }

    const totalDays = (new Date(end) - new Date(start)) / 86400000 + 1
    if (totalDays > MAX_RANGE_DAYS) {
      notifyFailed(
        `Rentang tanggal maksimal ${MAX_RANGE_DAYS} hari. Silakan pecah menjadi beberapa kali Recalculate.`
      )
      return
    }

    setBtnLoading(true)

    const payload = {
      start,
      end,
      module: props.type,
    }

    RecalculateService.recalculate(payload)
      .then((res) => {
        setBtnLoading(false)
        const summary = res.data.data

        if (summary && summary.range) {
          notifySuccess(
            `${props.name}: ${summary.range.updated} diperbarui, ${summary.range.inserted} baru, ` +
              `${summary.catch_up.length} data susulan ditambahkan`
          )
          if (summary.catch_up.length > 0) {
            props.onCatchUp(summary.catch_up)
          }
          return
        }

        notifySuccess(`${props.name} success recalculated`)
      })
      .catch((err) => {
        console.log(err)
        setBtnLoading(false)
        const data = err.response && err.response.data

        // Sebagian data gagal disimpan: tampilkan project yang gagal, data lain tetap tersimpan
        if (data && data.error && data.error.failed) {
          const ids = data.error.failed.map((f) => f.project_id)
          const shown = ids.slice(0, 10).join(', ') + (ids.length > 10 ? ', ...' : '')
          notifyFailed(`${data.message}: ${ids.length} project gagal (${shown})`)
          if (data.error.catch_up && data.error.catch_up.length > 0) {
            props.onCatchUp(data.error.catch_up)
          }
          return
        }

        // 400 (rentang tanggal) dan 409 (Recalculate lain sedang berjalan) membawa pesan dari backend
        notifyFailed((data && data.message) || 'Something went wrong!')
      })
  }

  return (
    <tr>
      <td>{props.no}</td>
      <td>{props.name}</td>
      <td>
        <Button
          title="Recalculate"
          button="btn-primary btn-sm"
          icon="fa fa-gear me-1"
          loading={btnLoading}
          onClick={recalculateHandler}
        />
      </td>
    </tr>
  )
}

export default RecalculateItem
